import { render, staticRenderFns } from "./8.vue?vue&type=template&id=0dc98f26&"
import script from "./8.vue?vue&type=script&lang=js&"
export * from "./8.vue?vue&type=script&lang=js&"
import style0 from "./8.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports